<shared-box class="tile-for-loyalty-program-product" [contentHorizontalPaddings]="true"
    [contentVerticalPaddings]="true">

    <shared-x-of-counter class="tile-for-loyalty-program-product__counter"
        *ngIf="programItem && !programItem?.isLoading" [current]="currCount" [of]="maxCount">
    </shared-x-of-counter>

    <shared-icons-counter [iconInactive]="iconInactive" [iconActive]="iconActive" [pathToImages]="pathToImages"
        [current]="currCount" [of]="maxCount" class="tile-for-loyalty-program-product__icons-counter"
        *ngIf="programItem && !programItem?.isLoading">
    </shared-icons-counter>

    <shared-header type="3" class="tile-for-loyalty-program-product__hd" marginTop="xs" marginBottom="sm"
        [loading]="programItem?.isLoading || !programItem">
        {{programItem?.program?.ProgramName}}
    </shared-header>

    <div class="tile-for-loyalty-program-product__desc" *ngIf="programItem && !programItem?.isLoading">
        {{description}}
    </div>


    <ng-container *ngIf="programItem?.isLoading || !programItem">
        <shared-loader-for-placeholder class="tile-for-loyalty-program-product__loader -for-description">
        </shared-loader-for-placeholder>
        <shared-loader-for-placeholder class="tile-for-loyalty-program-product__loader -for-description">
        </shared-loader-for-placeholder>
    </ng-container>

</shared-box>